import lodash from 'lodash';

export default class LodashService {
  constructor() {
    'ngInject';
    return lodash;
  }
};



// WEBPACK FOOTER //
// ./src/app/shared/services/lodash.js